import styled from "styled-components";

export const NafHr = styled.hr.attrs({ className: "NafHr" })`
  width: 4em;
  height: 0.4em;
  background: #fde440;
  border: none;
  display: block;
  margin-bottom: 1.5em;
`;
